module.exports = __webpack_public_path__ + "media/Casino slot machine - musical -wheels spinning- arpeggio - seamless looping 5.70da1b49.mp3";